import {Component, inject, Input} from '@angular/core';
import {DatePipe, NgIf} from '@angular/common';
import {UnitTypes} from '@modules/universal-billing/smart-meter/components/enums/unit-types.enum';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'meter-card',
  standalone: true,
  imports: [
    NgIf,
    DatePipe,
    TranslatePipe
  ],
  templateUrl: './meter-card.component.html',
  styleUrl: './meter-card.component.scss'
})
export class MeterCardComponent {
  @Input() data: any;
  @Input() property: string;
  @Input() buildingType: any;
  @Input() apartment: string;

  translateService = inject(TranslateService);

  protected readonly UnitTypes = UnitTypes;
}
